import { Component, OnInit } from "@angular/core";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-wizard-payment-failure',
    templateUrl: './payment-failure.component.html',
    imports: [CommonModule, TranslateModule]
})
export class OrderPaymentFailureComponent implements OnInit {

    constructor(
        public _orderWizardService: OrderWizardService
    ) {

     }

    ngOnInit(): void {
 
    }


}